import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { QRCodeSVG } from 'qrcode.react';

// QRIS di layar kasir. qris = { url, qrString, isProduction } dari qris_data backend.
// Sandbox: gambar QR dari Midtrans + pita TEST/SANDBOX di pojok area (bukan di atas QR, supaya tetap terbaca).
// Production: QR digambar sendiri dari qr_string (backend tidak mengirim tautan gambar).
const QrisKasir = ({ qris, orderId, ukuran = 220 }) => {
  const [gambarGagal, setGambarGagal] = useState(false);
  if (!qris) return null;
  const pakaiGambar = !qris.isProduction && qris.url && !gambarGagal;

  return (
    // Sandbox: QR diberi jarak atas 64px sehingga tidak pernah tertutup pita di pojok (pita menutup area
    // sudut sampai sekitar 55px), berapa pun lebar panel kasirnya.
    <Box sx={{ position: 'relative', overflow: 'hidden', pt: qris.isProduction ? 0 : '64px', pb: 1 }}>
      {!qris.isProduction && [
        { teks: 'TEST', sisi: { left: -32 }, putar: -45 },
        { teks: 'SANDBOX', sisi: { right: -32 }, putar: 45 },
      ].map((pita) => (
        <Box key={pita.teks} sx={{
          position: 'absolute', top: 10, ...pita.sisi, width: 110, transform: `rotate(${pita.putar}deg)`,
          bgcolor: '#ffd400', color: '#333', textAlign: 'center', py: 0.25, boxShadow: 1, pointerEvents: 'none', zIndex: 1,
        }}>
          <Typography sx={{ fontSize: 11, fontWeight: 800, letterSpacing: 1 }}>{pita.teks}</Typography>
        </Box>
      ))}

      <Box sx={{ width: ukuran, maxWidth: '100%', mx: 'auto', border: '1px solid #e5e7eb', borderRadius: 1.5, p: 1, bgcolor: 'white', boxSizing: 'border-box' }}>
        {pakaiGambar
          ? <img src={qris.url} alt="QRIS" style={{ display: 'block', width: '100%', height: 'auto' }} onError={() => setGambarGagal(true)} />
          : <QRCodeSVG value={qris.qrString || ''} size={ukuran} level="M" style={{ display: 'block', width: '100%', height: 'auto' }} />}
      </Box>
      {orderId && (
        <Typography variant="caption" sx={{ color: '#6b778c', mt: 1, display: 'block', textAlign: 'center', wordBreak: 'break-all' }}>
          Order ID: {orderId}
        </Typography>
      )}
    </Box>
  );
};

export default QrisKasir;
